import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { OKTA_CONFIG, OKTA_AUTH, OktaAuthModule, OktaAuthStateService, OktaAuthGuard } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../environments/environment';
import { AuthInterceptor } from './auth/auth.interceptor';

const oktaAuth = new OktaAuth(environment.okta);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideAnimations(), 
    provideHttpClient(withInterceptorsFromDi()),
    { provide: OKTA_CONFIG, useValue: { oktaAuth } },
    { provide: OKTA_AUTH, useValue: oktaAuth },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    OktaAuthStateService,
    OktaAuthGuard
  ]
};
